import React from "react";
import cx from "classnames";
import { dataTestIds } from "data-testids";
import { ReactComponent as TickIcon } from "../../../images/svg/icons/tick-icon.svg";
import { ReactComponent as TwoPerfs } from "../../../images/svg/icons/two-perfs.svg";
import "./CardButton.scss";

export interface ICardButtonProps {
  text: string;
  onHandleClick?: (value?: unknown) => void;
  isTicked: boolean;
  icon?: React.FC<React.SVGProps<SVGSVGElement>>;
  disabled?: boolean;
}

export const CardButton: React.FC<ICardButtonProps> = ({
  text,
  isTicked = false,
  icon = TwoPerfs,
  onHandleClick,
  disabled,
}) => {
  const IconComponent = icon;

  const renderIcon = () => {
    if (isTicked) {
      return (
        <span className="card-button__tick">
          <TickIcon />
        </span>
      );
    }

    return <span>{<IconComponent />}</span>;
  };

  return (
    <button
      data-testid={dataTestIds.componentLibrary["Atoms.CardButton.button"]}
      type="button"
      className={cx("card-button", {
        "card-button__ticked": isTicked,
        "card-button__disabled": disabled,
      })}
      onClick={() => onHandleClick?.()}
      disabled={disabled}
    >
      <div className="card-button__container">
        {renderIcon()}
        <span className={cx({ "card-button__bold": isTicked })}>{text}</span>
      </div>
    </button>
  );
};
